<template>
  <div>
      <TermosDeUsoComponent
      :id-termo="idTermo"
      style="max-width: 1100px; margin: 0 auto;"
      :buttonsFooter="true"
      @voltar="$router.go(-1)"
      @aceito="proximo"
      @cancelar="voltar"
      />
  </div>
</template>
<script>
import TermosDeUsoComponent from '@/components/TermosDeUso/TermosDeUsoComponent'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    TermosDeUsoComponent
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapState('Func53', ['idAgenda']),
    idTermo () {
      return this.$route.query.id
    }
  },
  methods: {
    ...mapActions('BreadCrumbsStore', ['updateIten']),
    proximo () {
      if (this.idAgenda === '1') {
        return this.$router.push({ path: '/53/novo', query: { step: 2 } })
      }
      const payload = { step: 1, value: 'Termos de Uso' }
      this.updateIten(payload)
      this.$router.push({ path: '/53/novo', query: { step: 3 } })
    },
    voltar () {
      this.$router.push({ path: '/53/novo', query: { step: 1 } })
    }
  }
}
</script>
